module.exports = __webpack_public_path__ + "media/assets/Plus-171d5b2504136469db532de40e56d010.svg";